module.exports = __webpack_public_path__ + "img/bitmap_datafee@3x.1db2af9c.png";